import { delay, getContext, race, select, take } from 'redux-saga/effects'
import { IStoreState } from '../states'
import { UserInfoTypeKeys } from '../types'

/**
 * userInfo.town is only populated once checkSession's SET_USER_INFO lands.
 * Any saga reading it right after a fresh page load (before checkSession
 * resolves) would otherwise read the initial { id: 0 } and hit the API
 * with an invalid townId. Wait for it once, then read again.
 */
export function* selectUserTown(): any {
  let town = yield select((state: IStoreState) => state.userInfo.town)
  if (!town?.id) {
    yield race({
      userInfo: take(UserInfoTypeKeys.SET_USER_INFO),
      timeout: delay(8000)
    })
    town = yield select((state: IStoreState) => state.userInfo.town)
  }
  return town
}

/**
 * The town the booking flow works on. A town in the URL (guest, iframe, direct link) or carried in
 * the navigation state from the stops step wins over the profile town: the stops on screen belong
 * to it, so services, availabilities and client info must come from the same town — also for a
 * guest who signs in half way and whose profile town is a different one.
 */
export function* selectBookingTownId(): any {
  const routerHistory = yield getContext('routerHistory')
  const urlTownId = new URLSearchParams(location.search).get('townId') ?? routerHistory.location.state?.townId
  if (urlTownId) return Number(urlTownId)

  const town = yield selectUserTown()
  return town?.id ?? 0
}
